export default {
  header: {
    notes: 'Header of agreement dialog',
    message: 'SAM online terms of service',
  },
  updated: {
    notes: 'Text in updated badge when there is a new version of agreement',
    message: 'Updated',
  },
  action: {
    accept: {
      notes: 'Accept agreement action',
      message: 'Accept',
      tooltip: {
        notes: 'Button tooltip displayed on disabled Accept button',
        message:
          'To accept the agreements, please read the complete text and check all acknowledgements at the end.',
      },
    },
    readMore: {
      notes: 'Title for a button that helps the user to scroll to the end',
      message: 'Read more',
    },
  },
  notification: {
    signFailed: {
      notes: 'Failed to sign agreement',
      message: 'Failed to sign agreement. {{message}}',
    },
  },
  type: {
    supply: {
      notes: 'Name of agreement type "terms and conditions of supply"',
      message: 'Terms and Conditions of Supply',
    },
    covid: {
      notes: 'Name of agreement type "covid clauses"',
      message: 'Covid Clause',
    },
    fulfillmentFees: {
      notes: 'A message about fees that may apply, that the user has to accept',
      message: 'I understand that shipping and handling fees may apply',
    },
  },
  revokeHelpText: {
    notes:
      'Instructions for the case when the user wants to revoke earlier approved agreements',
    message:
      'To revoke SAM online terms of service, please contact your local sales representative.',
  },
};
